// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"0d46c1b2","82":"0120295c","237":"7bb79ee3","354":"3b8825b2","454":"756b1a7d","487":"7cb166c3","507":"3570fba2","787":"28cb0dcd","810":"7e094355","836":"6a85f2c7","975":"6a999a8a"}[chunkId] + ".chunk.js";
};